import { useState, type FormEvent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { useAuth } from "../auth";
import { ApiRequestError } from "../api";

export function LoginPage() {
  const { user, login } = useAuth();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  if (user) return <Navigate to={(location.state as { from?: string } | null)?.from ?? "/"} replace />;

  async function submit(event: FormEvent) {
    event.preventDefault(); setSubmitting(true); setMessage("");
    try { await login(username, password); }
    catch (error) { setMessage(error instanceof ApiRequestError ? error.message : "The portal could not sign you in."); }
    finally { setSubmitting(false); setPassword(""); }
  }

  return (
    <main className="login-page">
      <section className="login-information">
        <div className="brand-logos large"><img src="/logos/RBIM.png" alt="RBIM" /><img src="/logos/CPD.png" alt="Commission on Population and Development" /></div>
        <span className="eyebrow light">Republic of the Philippines</span>
        <h1>Registry of Barangay Inhabitants and Migrants</h1>
        <p>Authorized online access for barangay supervision, municipal consolidation, and LGU administration.</p>
        <div className="security-callout"><LockKeyhole /><span>Your access is limited by your administrator-assigned role and locked geographic coverage.</span></div>
      </section>
      <section className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <span className="eyebrow">RBIM Online Portal</span><h2>Sign in securely</h2>
          <p>Use the individual account issued by your authorized RBIM/LGU system administrator.</p>
          <label>Username<input autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} required /></label>
          <label>Password<input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label>
          {message && <div className="form-error" role="alert">{message}</div>}
          <button className="primary-button" disabled={submitting}>{submitting ? "Signing in…" : "Sign in"}</button>
          <small>Need an account? Contact your authorized RBIM/LGU system administrator.</small>
          <small>Production access requires HTTPS and an approved LGU deployment.</small>
        </form>
      </section>
    </main>
  );
}
